<template>
  <div v-loading="fetchingCommercialAlternatives || fetchingDispensableAlternatives" class="medication-search-input">
    <!--
    <app-medication-search
      v-if="allowSubstitution"
      :value="value.clinicalMedication"
      :loading="searchingClinicalMedication"
      :medications="clinicalMedicationResults"
      @search="handleClinicalMedicationSearch"
      @input="handleSelectClinicalMedication" />
      -->
    <div v-if="labels" class="">
      <strong>Medicamento</strong>
    </div>
    <app-medication-select
      v-if="clinicalMedicationAlternatives.length > 0"
      :required="true"
      :value="value.clinicalMedication"
      :loading="searchingClinicalMedication"
      :medications="clinicalMedicationAlternatives"
      placeholder="Seleccionar Presentación de Medicamento"
      @input="handleSelectClinicalMedication" />

    <input
      v-else
      type="text"
      :value="value.clinicalMedication.display"
      class="medication-search-input__medication-concept form-control"
      disabled="disabled">

    <div v-if="labels" class="">
      <strong>Medicamento comercial</strong>
    </div>
    <app-medication-select
      :value="value.commercialMedication"
      :loading="fetchingCommercialAlternatives"
      :disable="fetchingCommercialAlternatives"
      :medications="commercialAlternatives"
      @input="handleSelectCommercialMedication" />
    <div v-if="labels">
      <strong>Medicamento comercial con envase</strong>
    </div>
    <app-medication-select
      :value="value.dispensableMedication"
      :loading="fetchingDispensableAlternatives"
      :disable="fetchingDispensableAlternatives"
      :medications="dispensableAlternatives"
      @input="handleSelectedDispensableMedication" />
  </div>
</template>

<script>
import AppMedicationSelect from '@/components/AppMedicationSelect';
import AppMedicationSearch from '@/components/AppMedicationSearch';
import _debounce from 'lodash/debounce';
import _cloneDeep from 'lodash/cloneDeep';
import _pick from 'lodash/pick';
import _get from 'lodash/get';

export default {
  name: 'MedicationReferenceInput',
  components: {
    AppMedicationSelect,
    AppMedicationSearch
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      default: ''
    },
    allowSubstitution: {
      type: Boolean,
      default: false
    },
    recommendedCommercialMedication: {
      type: String,
      default: null
    },
    basicReference: {
      type: String,
      default: null
    },
    labels: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clinicalMedicationResults: [],
      searchingClinicalMedication: false,
      fetchingCommercialAlternatives: false,
      searchingClinicalMedication: false,
      clinicalMedicationAlternatives: [],
      fetchingClinicalMedication: false,
      commercialAlternatives: [],
      fetchingDispensableAlternatives: false,
      dispensableAlternatives: [],
      resetMedications: false,
      allowedContainerTypes: [
        'Venta Público'
      ]
    };
  },
  created() {
    if (Object.keys(this.value.clinicalMedication).length) {
      this.fetchCommercialAlternatives(this.value.clinicalMedication);
    }
    if (Object.keys(this.value.commercialMedication).length) {
      this.fetchDispensableCommercialAlternatives(this.value.commercialMedication);
    }

    this.fetchClinicalMedication();
  },
  methods: {
    handleSelectedDispensableMedication(dispensableMedication) {
      this.dispensableMedication = _cloneDeep(dispensableMedication);
      this.$emit('input', {
        clinicalMedication: _pick(_cloneDeep(this.value.clinicalMedication), ['display', 'reference']),
        commercialMedication: _pick(_cloneDeep(this.value.commercialMedication), ['display', 'reference']),
        dispensableMedication: _pick(dispensableMedication, ['display', 'reference'])
      });
    },
    handleSelectCommercialMedication(commercialMedicationReference) {
      this.$emit('input', {
        clinicalMedication: _pick(_cloneDeep(this.value.clinicalMedication), ['display', 'reference']),
        commercialMedication: _pick(_cloneDeep(commercialMedicationReference), ['display', 'reference']),
        dispensableMedication: this.resetMedications ? {} : _pick(_cloneDeep(this.value.dispensableMedication), ['display', 'reference'])
      });
      this.dispensableAlternatives = [];
      this.resetMedications = true;
      this.fetchDispensableCommercialAlternatives(commercialMedicationReference);
    },
    handleSelectClinicalMedication(clinicalMedication) {
      this.$emit('input', {
        clinicalMedication: _pick(_cloneDeep(clinicalMedication), ['display', 'reference']),
        commercialMedication: {},
        dispensableMedication: {}
      });
      this.fetchCommercialAlternatives(clinicalMedication);
    },
    async fetchClinicalMedication() {
      if (this.basicReference == null) {
        return;
      }

      this.fetchingClinicalMedication = true;
      return this.$store.dispatch('fetchClinicalMedication', {
        reference: this.basicReference
      })
        .then(response => {
          this.clinicalMedicationAlternatives = response.data;
          if (_get(response, 'data', []).length === 1) {
            this.handleSelectClinicalMedication(response.data[0], true);
          }
        })
        .finally(() => {
          this.fetchingClinicalMedication = false;
        });
    },
    fetchCommercialAlternatives(clinicalMedication) {
      this.fetchingCommercialAlternatives = true;
      this.$store.dispatch('fetchCommercialAlternatives', clinicalMedication)
        .then(response => {
          this.commercialAlternatives = response.data;
          let matchRecomended = null;
          if (this.recommendedCommercialMedication) {
            matchRecomended = this.commercialAlternatives.find(m => m.reference === this.recommendedCommercialMedication);
            if (matchRecomended) {
              matchRecomended.recommended = true;
              this.handleSelectCommercialMedication(matchRecomended);
            }
          }
          if (!matchRecomended && this.commercialAlternatives.length === 1) {
            this.handleSelectCommercialMedication(this.commercialAlternatives[0]);
          }
        })
        .finally(() => {
          this.fetchingCommercialAlternatives = false;
        });
    },
    fetchDispensableCommercialAlternatives(commercialMedicationReference) {
      this.fetchingDispensableAlternatives = true;
      this.$store.dispatch('fetchDispensableCommercialAlternatives', commercialMedicationReference)
        .then(response => {
          this.dispensableAlternatives = response.data.filter(this.filterDispensableAlternatives);
          if (this.dispensableAlternatives.length === 1) {
            this.handleSelectedDispensableMedication(this.dispensableAlternatives[0]);
          }
        })
        .finally(() => {
          this.fetchingDispensableAlternatives = false;
        });
    },
    filterDispensableAlternatives(medicine) {
      let containerType = _get(medicine, 'attributes.details.containerType', null);
      return this.allowedContainerTypes.includes(containerType);
    },
    handleClinicalMedicationSearch: _debounce(function(search) {
      this.searchingClinicalMedication = true;
      this.clinicalMedicationResults = [];
      this.$store.dispatch('searchMedication', search)
        .then(response => {
          this.clinicalMedicationResults = response.data;
        })
        .finally(() => {
          this.searchingClinicalMedication = false;
        });
    }, 400)
  }
};
</script>

<style lang="scss">
.medication-search-input {
  display: flex;
  flex-direction: column;

  input {
    margin-bottom: $--spacing-2;
  }
}
</style>
